// src/helpers/localePath.js
import { i18n } from '@/plugins/i18n'
import { getSavedSiteLocale } from '@/helpers/siteLocale'

// Keep explicit for now; we can wire this to useLanguages() later
const DEFAULT_LOCALE = 'en'
const LOCALE_SEGMENT_RE = /^\/([a-z]{2}(?:-[A-Z]{2})?)(?=\/|$)/i

export function currentLocale() {
  const gl = i18n.global
  const live =
    gl && gl.locale && typeof gl.locale === 'object' && 'value' in gl.locale
      ? gl.locale.value
      : gl.locale
  return (live || getSavedSiteLocale() || DEFAULT_LOCALE).toLowerCase()
}

/** Strip a leading "/:locale" segment (if present) */
export function stripLeadingLocale(path) {
  const normalized = path.startsWith('/') ? path : `/${path}`
  return normalized.replace(LOCALE_SEGMENT_RE, '') || '/'
}

/** Build a pathname with the desired locale (no query/hash) */
export function localePath(pathname, locale = currentLocale()) {
  const base = stripLeadingLocale(pathname)
  return locale === DEFAULT_LOCALE ? base : `/${locale}${base}`
}

/** Build a fullPath (preserves ?query and #hash) */
export function localeFullPath(fullPath, locale = currentLocale()) {
  const [pathPlus, hash = ''] = fullPath.split('#')
  const [pathname, search = ''] = pathPlus.split('?')
  const nextPathname = localePath(pathname, locale)
  const q = search ? `?${search}` : ''
  const h = hash ? `#${hash}` : ''
  return `${nextPathname}${q}${h}`
}

/** Original route name without the `/:locale` `__loc` suffix. */
export function routeBaseName(route) {
  if (route?.meta?.baseName) return route.meta.baseName
  const name = route?.name && String(route.name)
  if (name?.endsWith('__loc')) return name.slice(0, -5)
  return name || null
}

/** Named location that keeps the current locale prefix (`Welcome` → `Welcome__loc`). */
export function localizedNamedLocation(name, route = {}) {
  const locale = route?.params?.locale
  if (locale) {
    return {
      name: `${name}__loc`,
      params: { ...route.params, locale },
    }
  }
  return { name }
}
